import {
  AtSign,
  Feather,
  FolderSearch,
  KeyRound,
  Layers3,
  Smartphone,
} from 'lucide-react'

const features = [
  {
    icon: AtSign,
    title: 'Any provider, one home',
    body: 'Connect iCloud, Gmail, Outlook, Fastmail, or any standards-based IMAP and SMTP account. Automatic settings discovery makes setup short.',
  },
  {
    icon: FolderSearch,
    title: 'Fast even when offline',
    body: 'Mail is cached locally in a searchable workspace. Switch folders, find a message, and read old threads without waiting on the network.',
  },
  {
    icon: KeyRound,
    title: 'Credentials stay protected',
    body: 'Passwords stay in your operating system keychain and never get written into the local mail database. Fewer secrets scattered across disk.',
  },
  {
    icon: Layers3,
    title: 'Multiple accounts',
    body: 'Keep work, personal, and project inboxes in reach without six browser tabs. Add an account whenever you need it.',
  },
  {
    icon: Feather,
    title: 'Writing that feels good',
    body: 'A focused composer, clean reply and forward flows, rich signatures, and enough formatting for real work without turning email into a design app.',
  },
  {
    icon: Smartphone,
    title: 'Same app, every screen',
    body: 'One consistent NewEmail experience across Windows, macOS, Linux, Android, and iOS—with the same accounts, mail, and thoughtfully tuned interface.',
  },
]

export function Features() {
  return (
    <section id="features" className="border-y border-border/70 bg-card py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4">
        <div className="max-w-2xl">
          <span className="font-mono text-sm font-semibold text-primary">// a better inbox</span>
          <h2 className="mt-3 text-balance text-3xl font-extrabold tracking-tight sm:text-4xl">
            Everything essential. Nothing in the way.
          </h2>
          <p className="mt-4 text-pretty leading-relaxed text-muted-foreground">
            NewEmail is built around a simple idea: email should feel calm, quick, and personal
            again. No engagement tactics, no dashboard clutter, no compromise on compatibility.
          </p>
        </div>
        <div className="mt-12 grid gap-x-8 gap-y-10 md:grid-cols-2 lg:grid-cols-3">
          {features.map(({ icon: Icon, title, body }) => (
            <article key={title} className="group">
              <span className="flex h-11 w-11 items-center justify-center rounded-xl border border-primary/15 bg-secondary text-primary transition-transform group-hover:-translate-y-1">
                <Icon className="h-5 w-5" />
              </span>
              <h3 className="mt-5 text-lg font-bold tracking-tight">{title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{body}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  )
}
